@if (state(); as state) {
  <app-organization-sidebar-layout>
    <app-page-header>
      <div class="flex flex-col gap-2.5">
        <div class="flex gap-3 items-center">
          <ui-button
            [iconOnly]="true"
            mode="outlined"
            class="flex-none"
            [routerLink]="['/organizations', organizationId(), 'supplier-contracts']"
          >
            <ng-icon name="heroArrowLeft" size="20" class="!block" />
          </ui-button>
          <app-page-title class="flex-1">
            @if (state.isLoading) {
              <ui-skeleton class="block w-[400px] h-[36px]" />
            } @else if (state.error) {
              {{ 'cockpit.supplierContracts.details.pageTitle' | transloco }}
            } @else {
              {{ state.data?.productName }}
            }
          </app-page-title>
        </div>
        <app-supplier-contracts-details-breadcrumb-nav
          [organizationId]="organizationId()"
          [supplierContractId]="supplierContractId()"
        />
      </div>
    </app-page-header>

    @if (!state.error) {
      <app-supplier-contracts-details-nav
        [contractCheckAlerts]="state.data?.latestCheckResult?.alertCount ?? 0"
        slot="sticky-header"
      />
    }

    @if (!state.error) {
      <div class="flex flex-col gap-5">
        <div>
          <router-outlet />
        </div>
      </div>
    } @else {
      <app-error-page
        [error]="state.error"
        (clickBack)="router.navigate(['/organizations', organizationId(), 'supplier-contracts'])"
        class="block"
        style="height: calc(100vh - 20rem)"
      />
    }
  </app-organization-sidebar-layout>
}
